<ng-container [formGroup]="formGroup">
  <div class="x-input-label flex flex-row gap-3">
    <input
        tuiCheckbox
        type="checkbox"
      [formControlName]="FormFields.HasProtectiveCase"
      size="m"
    />
    <div class="flex items-center">
      {{ 'request_form.devices.protective_case.there_is_case' | translate }}
    </div>
  </div>

  @if (hasProtectiveCaseField.value) {
    <div class="pl-3">
      <div class="x-input-label">
        {{ 'request_form.devices.protective_case.case_number' | translate }}
      </div>
      <div class="flex flex-col">
        <tui-textfield
[tuiNumberFormat]="{precision: 0}"          
         
          
          tuiTextfieldSize="m"
          
        >
        
<input tuiInputNumber [formControlName]="FormFields.ProtectiveCaseNumber" [min]="1" />
</tui-textfield>
      </div>
      @if (
        protectiveCaseNumberField.errors?.[
          protectiveCaseNumberRequiredValidationError
        ] && protectiveCaseNumberField.touched
      ) {
        <tui-error
          [error]="
            'request_form.devices.protective_case.error_required' | translate
          "
          class="ml-2"
        ></tui-error>
      }
    </div>
  }
</ng-container>
